// this does not use `contexify` because query context should not trigger re-render
import {createContext, useContext} from 'react';

import {QueryContextManager} from 'common/query-context';

const context = createContext<QueryContextManager>(null);

export const QueryContextManagerProvider = context.Provider;
export const QueryContextManagerConsumer = context.Consumer;
export const useQueryContextManager = () => useContext(context);
